import React, { Fragment, useState, useEffect } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Journey from '../../components/journey/journey';


const PricingPage = (props) => {

    const [pdata, setPdata] = useState([]);
    const [fplan, setFplan] = useState({});
    const [isSticky, setIsSticky] = useState(false);

    const getPackageDetails = async () => {
        try {
            const response = await fetch('https://api.easemyhotel.io/api/package_list');
            // console.log(response)
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if(data.code === 200) {
                setPdata(data.data);
                setFplan(data.fplan);
            }
        } catch (error) {
            console.error('There has been a problem with your fetch operation:', error);
        }   
    }

    const buyPackage = async (data) => {
        localStorage.setItem('package', JSON.stringify(data));
        window.location.href = '/checkout';
    }

    useEffect(() => {
        getPackageDetails();

        const handleScroll = () => {
            setIsSticky(window.scrollY > 650 && window.scrollY < 1350);
          };
      
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);

    }, []);

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                
                <section className="free_plan_section section_space">
                    <div className="container">
                        <div className="heading_block text-center">
                            <h2 className="heading_text mb-0">
                                Try For Free
                            </h2>
                            <p className="mb-4">Start for free — includes all the features of Growth Plan.</p>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-4 p-4"  style={{border:"1px solid #ddd", borderRadius:"10px",background:"#e5dbfc"}}>
                                <div className="pricing_card free_card">
                                    <div className="pricing_card_header">
                                        <div className='row'>
                                            <div className='col-8'>
                                                <h3 className="pricing_card_title mb-0">Free Monthly Plan</h3>
                                                <p>(Growth Plan)</p>
                                                {/* <img src={offerBanner} alt="Best Offer" className="best_offer_img"/> */}
                                                <p className="mb-3">Up to {fplan.room_lim} rooms • {fplan.user_lim} user</p>
                                            </div>
                                            <div className='col-4 text-end'>
                                            <p className="pricing_card_price1"><span>₹{fplan.pack_price}</span></p>
                                            </div>
                                        </div>
                                        {/* <p className="pricing_card_price">Perfect to try features</p> */}
                                        <div className='text-right'>
                                            <button className="btn buy_now_new" onClick={()=>buyPackage(fplan)}>Get Started</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            
                <section className="pricing_section section_space pt-2">
                    <div className="container">
                        <div className="heading_block text-center">
                            <h2 className="heading_text mb-0">
                                Plans & Pricing
                            </h2>
                        </div>
                        
                        <div className="row justify-content-center">
                             <ul className="pricing_list">
                                <li className="pricing_item">
                                    
                                </li>
                                { pdata.map((item, index) => (
                                <li className="pricing_item" key={index}>
                                    <div className="pricing_card">
                                        <div className="pricing_card_header">
                                            <h3 className="pricing_card_title">{item.pack_title}</h3>
                                            <p className="pricing_card_price">Essential tools to manage and grow your hotel efficiently.</p>
                                            <p className="pricing_card_price1 list_price"><span>{item.pack_price}</span> INR/ Month</p>
                                            <p className='list_price'>₹{item.sell_price} per month, billed <br/> annually</p>
                                            <button className="btn buy_now_new" onClick={()=>buyPackage(item)}>Buy Now</button>
                                        </div>
                                    </div>
                                </li>
                                ))} 

                                {/* <li className="pricing_item">
                                    <div className="pricing_card">
                                            <div className="pricing_card_header">
                                                <h3 className="pricing_card_title">Growth</h3>
                                                <p className="pricing_card_price">Essential tools to manage and grow your hotel efficiently.</p>
                                                <p className="pricing_card_price1"><span>6,250</span> INR/ Month</p>
                                                <p>₹5,900 per month, billed <br/> annually</p>
                                                <button className='btn buy_now_new'>Buy Now</button>
                                            </div>
                                    </div>
                                </li>

                                <li className="pricing_item">
                                    <div className="pricing_card">
                                            <div className="pricing_card_header">
                                                <h3 className="pricing_card_title">Business</h3>
                                                <p className="pricing_card_price">Essential tools to manage and grow your hotel efficiently.</p>
                                                <p className="pricing_card_price1"><span>10,000</span> INR/ Month</p>
                                                <p>₹9,000 per month, billed <br/> annually</p>
                                                <button className='btn buy_now_new'>Buy Now</button>
                                            </div>
                                    </div>
                                </li>*/}
                             </ul> 
                        </div>

                        <div className="row">
                            <table className="table table-striped table-hover table-responsive-sm features_tbl">
                                <thead>
                                    <tr className={`${isSticky ? 'fixed_nev' : ''}`}>
                                        <th scope="col" style={{fontWeight:'normal', fontSize:'30px'}}>Features</th>
                                        { pdata.map((item, index) => (
                                            <th scope="col" className='pack_nav' style={{textAlign:'center'}}>{item.pack_title}</th>
                                            ))} 
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Booking System</td>
                                        <td><i className="fa fa-check"></i></td>
                                        <td><i className="fa fa-check"></i></td>
                                        <td><i className="fa fa-check"></i></td>
                                    </tr>

                                    {/* <tr>
                                        <td>Properties</td>
                                        <td>Unlimited</td>
                                        <td>Unlimited</td>
                                        <td>Unlimited</td>
                                    </tr> */}


                                    <tr>
                                        <td>Rooms</td>
                                        {pdata && pdata.map((item, index) => (
                                            <td key={index}>{item.room_lim}</td>
                                        ))}
                                    </tr>

                                    <tr>
                                        <td>Users</td>
                                        {pdata && pdata.map((item, index) => (
                                            <td key={index}>{item.user_lim}</td>
                                        ))}
                                    </tr>

                                    <tr>
                                        <td>Front Desk</td>
                                        <td><i className="fa fa-check"></i></td>
                                        <td><i className="fa fa-check"></i></td>
                                        <td><i className="fa fa-check"></i></td>
                                    </tr>

                                    <tr>
                                        <td>House Keeping</td>
                                        <td><i className="fa fa-check"></i></td>
                                        <td><i className="fa fa-check"></i></td>
                                        <td><i className="fa fa-check"></i></td>
                                    </tr>

                                    <tr>
                                        <td>Onboarding</td>
                                        <td>1:1</td>
                                        <td>1:1</td>
                                        <td>1:1</td>
                                    </tr>

                                    <tr>
                                        <td>Support</td>
                                        <td>Call/WhatsApp</td>
                                        <td>Call/WhatsApp</td>
                                        <td>Priority Support</td>
                                    </tr>

                                    <tr>
                                        <td>Inventory Management (Stock Alert)
                                            <br/>
                                            <span style={{fontSize:'10px', color:'red'}}>
                                                <i class="fa fa-asterisk" aria-hidden="true"></i> Coming Soon
                                            </span>
                                        </td>
                                        <td>Addon</td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Analytics</td>
                                        <td>Basic</td>
                                        <td>Advance</td>
                                        <td>Advance</td>
                                    </tr>

                                    <tr>
                                        <td>Channel Manager
                                        <br/>
                                        <span style={{fontSize:'10px', color:'red'}}><i class="fa fa-asterisk" aria-hidden="true"></i> Coming Soon</span>
                                        </td>
                                        <td>Addon</td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Expense Management/Accounting
                                        <br/>
                                        <span style={{fontSize:'10px', color:'red'}}><i class="fa fa-asterisk" aria-hidden="true"></i> Coming Soon</span>
                                        </td>
                                        <td>Addon</td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>Restaurant and Dining Management <br/> System (POS & KOT) (Room Dining)</td>
                                        <td>Addon</td>
                                        <td><i className="fa fa-check"></i></td>
                                        <td><i className="fa fa-check"></i></td>
                                    </tr>

                                    <tr>
                                        <td>HR Management/Employee management
                                        <br/>
                                        <span style={{fontSize:'10px', color:'red'}}><i class="fa fa-asterisk" aria-hidden="true"></i> Coming Soon</span>
                                        </td>
                                        <td>Addon</td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                        <td>
                                        <i className="fa fa-check"></i>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td>Website</td>
                                        <td>Addon</td>
                                        <td>Addon</td>
                                        <td>Included (with yearly plan)</td>
                                    </tr>

                                    <tr>
                                        <td>Directory Listing</td>
                                        <td>Normal</td>
                                        <td>People's Choice</td>
                                        <td>Category Leader</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        {pdata && pdata.map((item, index) => (
                                            <td key={index}>
                                                <button className='btn buy_now_new' onClick={()=>buyPackage(item)}>Buy Now</button>
                                            </td>
                                        ))  }
                                    </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                {/* <section className="section_space pt-0">
                    <div className="container">
                        <div className="row">
                            <div className='col-lg-12'>
                                <h2>Single Module</h2>
                                <p className='mb-0'>Get started with Drag & Drop Addon </p>
                            </div>
                            <div className='col-lg-12'>
                                <ul className='unordered_list p-0 priceing_list'>
                                    <li className='first_item'>

                                    <div className='billing_option'>
                                         Bill Monthly
                                        <label class="switch">
                                            <input type="checkbox"/>
                                            <span class="slider"></span>
                                        </label> Billed Yearly
                                        </div>

                                        <div className='text-center'>
                                           <h3>₹1500</h3>
                                            <span>Per Month</span>

                                            <button className='btn buy_now_new'>Buy Now</button>

                                        </div>
                                    </li>
                                    <li className='second_item'>
                                        <h3>Channel Manager (OTA)</h3>
                                        <ul className='inside_priceing_list'>
                                            <li><i className="fa fa-check"></i> Booking System</li>
                                            <li><i className="fa fa-check"></i> Channel Manager</li>
                                            <li><i className="fa fa-check"></i> Number of Rooms Added</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                            <div className='col-lg-12'>
                                <ul className='unordered_list p-0 priceing_list'>
                                    <li className='first_item'>

                                    <div className='billing_option'>
                                         Bill Monthly
                                        <label class="switch">
                                            <input type="checkbox"/>
                                            <span class="slider"></span>
                                        </label> Billed Yearly
                                        </div>

                                        <div className='text-center'>
                                           <h3>₹699</h3>
                                            <span>Per Month</span>

                                            <button className='btn buy_now_new'>Buy Now</button>

                                        </div>
                                    </li>
                                    <li className='second_item'>
                                        <h3>Restaurant and Dining Management System (POS & KOT)</h3>
                                        <ul className='inside_priceing_list'>
                                            <li><i className="fa fa-check"></i> POS (Point of Sale)</li>
                                            <li><i className="fa fa-check"></i> Table Management</li>
                                            <li><i className="fa fa-check"></i> KOT (Kitchen Order Ticket)</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </section> */}

                <Journey />

            </main>
            {/* <CtaSection /> */}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PricingPage;
